import { msg } from '@lingui/core/macro';
import { SportType } from 'modules/core/domain/enums/sport-type';
import type { MessageDescriptor } from 'shared/i18n';

/** Подписи видов спорта. Названия киберспортивных дисциплин — имена собственные, но тоже в каталоге. */
export const SPORT_TYPE_LABELS: Record<SportType, MessageDescriptor> = {
  [SportType.football]: msg`Футбол`,
  [SportType.floorball]: msg`Флорбол`,
  [SportType.hockey]: msg`Хоккей`,
  [SportType.basketball]: msg`Баскетбол`,
  [SportType.volleyball]: msg`Волейбол`,
  [SportType.waterpolo]: msg`Водное поло`,
  [SportType.bowling]: msg`Боулинг`,
  [SportType.minifootball]: msg`Минифутбол`,
  [SportType.tennis]: msg`Теннис`,
  [SportType.tabletennis]: msg`Настольный теннис`,
  [SportType.badminton]: msg`Бадминтон`,
  [SportType.darts]: msg`Дартс`,
  [SportType.beachvolleyball]: msg`Пляжный волейбол`,
  [SportType.beachfootball]: msg`Пляжный футбол`,
  [SportType.grasshockey]: msg`Хоккей на траве`,
  [SportType.counterstrike2]: msg`Counter Strike 2`,
  [SportType.dota2]: msg`Dota 2`,
  [SportType.leagueoflegends]: msg`League of Legends`,
  [SportType.mlbb]: msg`Mobile Legends: Bang Bang`,
  [SportType.standoff2]: msg`Standoff 2`,
};

/**
 * Вид спорта с бэкенда приходит и заглавными (`FOOTBALL`), а enum строчный. Неизвестное значение —
 * `undefined`: подпись по месту берёт исходную строку.
 */
export function getSportTypeLabel(sportType?: string | null): MessageDescriptor | undefined {
  return sportType ? SPORT_TYPE_LABELS[sportType.toLowerCase() as SportType] : undefined;
}
